import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = ["title"];
import { I18nInfo } from '@/user/models';
import { getBadgeColor, getBadgeText } from '@/user/models/common/level-badge';
import { computed } from 'vue';
import { clsx } from 'clsx';
import { Badge, FilledButton } from '@/user/components/common';
import { formatDate } from '@/user/helpers/util';
import { useRouter } from 'vue-router';
export default /*@__PURE__*/ _defineComponent({
    __name: 'RecommendedLectures',
    props: {
        lectures: {}
    },
    setup(__props) {
        const props = __props;
        const contents = computed(() => props.lectures || []);
        const t = new I18nInfo('eduCenter');
        const t_common = new I18nInfo('common');
        const styles = {
            container: clsx('flex flex-row gap-16 overflow-x-auto pl-16 pr-16 mt-24', 'desktop:px-0 desktop:mt-32'),
            item: clsx('flex flex-col w-312 shrink-0 border-1 border-gray-250 rounded-12 py-28 px-24 h-full', 'desktop:w-[calc((100%-32px)/3)] desktop:p-24'),
            imageCover: clsx('w-full h-150', 'desktop:h-160'),
            image: clsx('w-full h-full object-cover'),
            title: clsx('block mt-12 text-title-2 line-clamp-2 h-[3.5rem]', 'desktop:text-title-1 desktop:h-[3.5rem]'),
            infoBox: clsx('grid grid-cols-[max-content_1fr] gap-x-16 gap-y-12 mt-20 h-[140px]', 'desktop:gap-x-20 desktop:gap-y-16 desktop:h-[160px]'),
            infoItemTitle: clsx('flex-shrink-0 text-body-5 text-gray-600 whitespace-nowrap pr-4', 'desktop:text-body-4 desktop:pr-8'),
            infoItemDesc: clsx('flex-1 text-body-5 text-gray-800 break-words leading-tight', 'desktop:text-body-4'),
            button: clsx('mt-20 w-full'),
        };
        const router = useRouter();
        function handleDetailClick(item) {
            router.push({ name: 'AttendDetail', params: { id: item.id } });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("ul", {
                class: _normalizeClass(styles.container)
            }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(contents.value, (item, idx) => {
                    return (_openBlock(), _createElementBlock("li", {
                        key: idx,
                        class: _normalizeClass(styles.item)
                    }, [
                        _createVNode(_unref(Badge), {
                            color: _unref(getBadgeColor)(item.level)
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(getBadgeText)(item.level)), 1)
                            ]),
                            _: 2
                        }, 1032, ["color"]),
                        _createElementVNode("strong", {
                            class: _normalizeClass(styles.title),
                            title: item.title
                        }, _toDisplayString(item.title), 11, _hoisted_1),
                        _createElementVNode("dl", {
                            class: _normalizeClass(styles.infoBox)
                        }, [
                            _createElementVNode("dt", {
                                class: _normalizeClass(styles.infoItemTitle)
                            }, _toDisplayString(_unref(t).translate('home.sectionCurriculum.educationDate')), 3),
                            _createElementVNode("dd", {
                                class: _normalizeClass(styles.infoItemDesc)
                            }, _toDisplayString(_unref(formatDate)(item.startAt, item.finishAt)), 3),
                            _createElementVNode("dt", {
                                class: _normalizeClass(styles.infoItemTitle)
                            }, _toDisplayString(_unref(t).translate('home.sectionCurriculum.educationType')), 3),
                            _createElementVNode("dd", {
                                class: _normalizeClass(styles.infoItemDesc)
                            }, _toDisplayString(_unref(t_common).translate(`enums.method.${item.method}`)), 3),
                            _createElementVNode("dt", {
                                class: _normalizeClass(styles.infoItemTitle)
                            }, _toDisplayString(_unref(t).translate(`account.table.progressState`)), 3),
                            _createElementVNode("dd", {
                                class: _normalizeClass(styles.infoItemDesc)
                            }, _toDisplayString(_unref(t_common).translate(`enums.state.${item.state}`)), 3),
                            _createElementVNode("dt", {
                                class: _normalizeClass(styles.infoItemTitle)
                            }, _toDisplayString(_unref(t).translate(`account.table.target`)), 3),
                            _createElementVNode("dd", {
                                class: _normalizeClass(styles.infoItemDesc)
                            }, _toDisplayString(_unref(t_common).translate(`enums.target.${item.target}`)), 3)
                        ], 2),
                        _createVNode(_unref(FilledButton), {
                            color: "gray",
                            "mobile-size": "medium",
                            "desktop-size": "large",
                            class: _normalizeClass(styles.button),
                            onClick: ($event) => (handleDetailClick(item))
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(t_common).translate('button.detail')), 1)
                            ]),
                            _: 1
                        }, 8, ["class", "onClick"])
                    ], 2));
                }), 128))
            ], 2));
        };
    }
});
